/** Passport SDK 由页面 HTML 中的 defer script 引入。 */
export const isPassportSdkReady = () =>
    typeof window !== 'undefined' &&
    typeof window.login?.setConfig === 'function' &&
    typeof window.login?.checkPhoneApi === 'function';

export const waitForPassportSdk = (timeoutMs = 15000): Promise<void> =>
    new Promise((resolve, reject) => {
        if (isPassportSdkReady()) {
            resolve();

            return;
        }

        const started = performance.now();

        const tick = () => {
            if (isPassportSdkReady()) {
                resolve();

                return;
            }

            if (performance.now() - started >= timeoutMs) {
                reject(new Error('Passport SDK load timeout'));

                return;
            }

            requestAnimationFrame(tick);
        };

        tick();
    });

export const withReadyPassport = <T>(task: () => T | Promise<T>): Promise<T> => {
    if (!isPassportSdkReady()) {
        return Promise.reject(new Error('Passport SDK is not ready'));
    }

    return Promise.resolve(task());
};
